export const Logo = ({ size, className = "" }) => (
  <img
    src="/logo-192.webp"
    srcSet="/logo-192.webp 192w, /logo-512.webp 512w"
    sizes="96px"
    alt="LUMINA STUDIO · El arte de recordar"
    className={`rounded-full ${className}`}
    style={size ? { width: size, height: size } : undefined}
  />
);
